import { render, staticRenderFns } from "./WarehouseAreaSelect.vue?vue&type=template&id=00ce7512&"
import script from "./WarehouseAreaSelect.vue?vue&type=script&lang=js&"
export * from "./WarehouseAreaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports